import { Box, Grid } from '@mui/material'
import React from 'react'
import TestimonialSlider from './Sliders/TestimonialSlider';
import SectionTitle from './SectionTitle';

const TestimonialSection = ({ testimonials }) => {
  const { header_title = [], header_desc = '', sliders = [] } = testimonials || {};
  return (
    <Box sx={{ p: 7, pb:10 }}>
      <Grid container sx={{ mb: 5 }}>
        <Grid item xs={12} md={12}>
          <SectionTitle align='center' variant={'h4'} header={header_title} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} lg={10} xl={8} sx={{ margin: 'auto' }}>
          <TestimonialSlider slides={sliders} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default TestimonialSection